module.exports = __webpack_public_path__ + "static/img/rs.43b012ca.svg";